"use strict";

exports.__esModule = true;
var _ElementEditorChooseTemplateDialog = require("./ElementEditorChooseTemplateDialog");
Object.keys(_ElementEditorChooseTemplateDialog).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ElementEditorChooseTemplateDialog[key]) return;
  exports[key] = _ElementEditorChooseTemplateDialog[key];
});